import { AddProduct as CatalogAddProduct } from './AddProduct';

export default CatalogAddProduct;
